import { MetadataEntityBase } from '../../abstract-metadata-entity-base';
import { IBizFlowchartEntity } from '../interface-biz-flowchart-entity';

/**
 * ä¸å¡åºæ¯å¾å®ä½ç±»
 */
export class AifBizFlowchartEntity extends MetadataEntityBase implements IBizFlowchartEntity {

}